export default __webpack_public_path__ + "static/media/mobile-app.88d70b1a.svg";